import { render, staticRenderFns } from "./StockSerial.vue?vue&type=template&id=4d142382&"
import script from "./StockSerial.vue?vue&type=script&lang=js&"
export * from "./StockSerial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports